// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3L2-X","rightAdornment":"Header_rightAdornment__1-AUI"};